import { CapaLlegendaSVG24, CapaLlegendaSVG16 } from './CapaLlegendaIconsElement';

export const renderErrorIcon = (fontSizeEnabled) => (
  <CapaLlegendaSVG24
    fontSizeEnabled={fontSizeEnabled}
    marginTop="3px"
    viewBox="0 0 486.463 486.463"
    style={{ enableBackground: 'new 0 0 486.463 486.463' }}
    fill="#febf00">
    <g>
      <g>
        <path d="M243.225,333.382c-13.6,0-25,11.4-25,25s11.4,25,25,25c13.1,0,25-11.4,24.4-24.4    C268.225,344.682,256.925,333.382,243.225,333.382z" />
        <path d="M474.625,421.982c15.7-27.1,15.8-59.4,0.2-86.4l-156.6-271.2c-15.5-27.3-43.5-43.5-74.9-43.5s-59.4,16.3-74.9,43.4    l-156.8,271.5c-15.6,27.3-15.5,59.8,0.3,86.9c15.6,26.8,43.5,42.9,74.7,42.9h312.8    C430.725,465.582,458.825,449.282,474.625,421.982z M440.625,402.382c-8.7,15-24.1,23.9-41.3,23.9h-312.8    c-17,0-32.3-8.7-40.8-23.4c-8.6-14.9-8.7-32.7-0.1-47.7l156.8-271.4c8.5-14.9,23.7-23.7,40.9-23.7c17.1,0,32.4,8.9,40.9,23.8    l156.7,271.4C449.325,369.882,449.225,387.482,440.625,402.382z" />
        <path d="M237.025,157.882c-11.9,3.4-19.3,14.2-19.3,27.3c0.6,7.9,1.1,15.9,1.7,23.8c1.7,30.1,3.4,59.6,5.1,89.7    c0.6,10.2,8.5,17.6,18.7,17.6c10.2,0,18.2-7.9,18.7-18.2c0-6.2,0-11.9,0.6-18.2c1.1-19.3,2.3-38.6,3.4-57.9    c0.6-12.5,1.7-25,2.3-37.5c0-4.5-0.6-8.5-2.3-12.5C260.825,160.782,248.925,155.082,237.025,157.882z" />
      </g>
    </g>
  </CapaLlegendaSVG24>
);

export const renderDefaultIcon = (fontSizeEnabled) => (
  <CapaLlegendaSVG16 fontSizeEnabled={fontSizeEnabled} id="NoRep" viewBox="0 0 512 512" fill="white">
    <g>
      <rect x="10.5" y="357.7" class="st2" width="145" height="145" />
      <rect x="10.5" y="183.9" class="st2" width="145" height="145" />
      <rect x="182.7" y="357.7" class="st2" width="145" height="145" />
      <rect x="182.7" y="183.9" class="st3" width="145" height="145" />
      <rect x="10.5" y="9.9" class="st3" width="145" height="145" />
      <rect x="182.7" y="9.8" class="st3" width="145" height="145" />
      <rect x="356.5" y="184.7" class="st3" width="145" height="145" />
      <rect x="356.5" y="356.7" class="st3" width="145" height="145" />
      <polygon class="st2" points="9.9,8.2 505.4,8.2 505.4,501.8 356,501.8 356,326 184.9,326 184.9,155 9.9,155  " />
    </g>
  </CapaLlegendaSVG16>
);

export const renderChildIcon = (fontSizeEnabled) => (
  <CapaLlegendaSVG16 fontSizeEnabled={fontSizeEnabled} fill="white" y="-2px" viewBox="0 0 17.2 14.3">
    <path d="M0.1,0.1v14h17v-14H0.1 M4.1,2.1v2h-2v-2H4.1 M2.1,8.1v-2h2v2H2.1 M2.1,10.1h2v2h-2V10.1 M15.1,12.1h-9v-2h9  V12.1 M15.1,8.1h-9v-2h9V8.1 M15.1,4.1h-9v-2h9V4.1z" />
  </CapaLlegendaSVG16>
);
